<template>
  <el-config-provider :locale="appStore.locale" :size="appStore.size">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import useSettingsStore from '@/store/modules/settings';
import { handleThemeStyle } from '@/utils/theme';
import useAppStore from '@/store/modules/app';

const appStore = useAppStore();

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
<style lang="scss">
.button_style{
  background-color: #76281c!important;
  &:focus-visible{
    outline:0px!important;
  }
  &:hover{
    background-color:#76281c!important;
    color: #fff!important;
  }
}
</style>